import { Button } from '@yhelp/ui';

export function WelcomeModal({
  onStartTour,
  onDismiss,
}: {
  onStartTour: () => void;
  onDismiss: () => void;
}) {
  return (
    <div className="fixed inset-0 z-[95] flex items-center justify-center p-4" role="presentation">
      <button
        type="button"
        className="absolute inset-0 bg-yhelp-black/60 animate-fade-in motion-reduce:animate-none"
        aria-label="Fechar"
        onClick={onDismiss}
      />
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="welcome-title"
        className="surface-elevated relative z-10 w-full max-w-md animate-fade-in-up p-8 motion-reduce:animate-none"
      >
        <span className="inline-flex rounded-full bg-yhelp-yellow px-3 py-1 text-xs font-bold text-yhelp-black">
          Primeiro acesso
        </span>
        <h2
          id="welcome-title"
          className="mt-4 text-2xl font-extrabold text-yhelp-black dark:text-white"
        >
          Bem-vindo ao yHelp
        </h2>
        <p className="mt-3 text-sm leading-relaxed text-muted">
          Quer um tour guiado para conhecer chamados, dashboard e anexos? Você também pode explorar
          sozinho e iniciar tours específicos pelo botão de ajuda.
        </p>
        <div className="mt-6 flex flex-col gap-2 sm:flex-row">
          <Button className="flex-1" onClick={onStartTour}>
            Iniciar tour de boas-vindas
          </Button>
          <Button className="flex-1" variant="secondary" onClick={onDismiss}>
            Explorar sozinho
          </Button>
        </div>
      </div>
    </div>
  );
}
